export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.REACT_APP_APIKEY || "AIzaSyCLiTOh71RByTo9Wgxa2FmArLulJwf7BRM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.REACT_APP_AUTHDOMAIN || "csi-official-calicut.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.REACT_APP_PROJECTID || "csi-official-calicut",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.REACT_APP_STORAGEBUCKET || "csi-official-calicut.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.REACT_APP_MESSAGING_SENDER || "1049551479555",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.REACT_APP_APP_ID || "1:1049551479555:web:b5547a7bfddd6694eb7f36",
};

export default firebaseConfig;
